export const updatePrices = {
    show: 'No hay registros para mostrar.',
    iconOfActions: [],
    columns: [
      {
        title: 'Tipo Despacho',
        name: 'dispatchType',
        type: 'string',
        editable: false,
        align: 'center',
        value: (element: any) => element.dispatchType
      },
      {
        title: 'SKU',
        name: 'internalCode',
        type: 'string',
        editable: false,
        align: 'left',
        value: (element: any) => element.internalCode
      },
      {
        title: 'Producto',
        name: 'line',
        type: 'string',
        editable: false,
        align: 'center',
        value: (element: any) => element.line
      },
      {
        title: 'Cantidad',
        name: 'quantity',
        type: 'string',
        editable: false,
        align: 'center',
        value: (element: any) => element.quantity
      },
      {
        title: 'Precio',
        name: 'price',
        type: 'string',
        editable: false,
        align: 'center',
        value: (element: any) => element.price
      },
      {
        title: 'Promoción',
        name: 'pricePromotion',
        type: 'number',
        editable: true,
        align: 'center',
        value: (element: any) => element.pricePromotion
      }
    ]
  };
